// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue,
} from "firebase/remote-config";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDwh0f-Macqf8nyXQJPSU_Fpx8qEdSxrLY",
  authDomain: "ivisaas.firebaseapp.com",
  projectId: "ivisaas",
  storageBucket: "ivisaas.firebasestorage.app",
  messagingSenderId: "917707222290",
  appId: "1:917707222290:web:b86ba199fae7ea95cf17cb",
  measurementId: "G-DGLHF0Q69Z",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
remoteConfig.defaultConfig = {
  server_url_test: "aplicacao.ivitech.com.br/hivisaas",
  server_url_prod: "aplicacao.ivitech.com.br/ivisaas",
};

export const storage = getStorage(app);

export const activateFirebaseConfig = async (
  suffix: string,
): Promise<string> => {
  return new Promise<string>(async (resolve, reject) => {
    try {
      await fetchAndActivate(remoteConfig);

      if (suffix === "dev") {
        const value = getValue(remoteConfig, "server_url_dev");
        resolve(`https://${value.asString()}/api/v2`);
      } else if (suffix === "teste") {
        const value = getValue(remoteConfig, "server_url_test");
        resolve(`https://${value.asString()}/api/v2`);
      } else if (suffix === "local") {
        resolve("http://192.168.3.121:8080/divisaas/api/v2");
      } else {
        const value = getValue(remoteConfig, "server_url_prod");
        // console.log(value.asString());
        resolve(`https://${value.asString()}/api/v2`);
      }
    } catch (err) {
      //console.log(err);
      reject({ message: "Network Error" });
    }
  });
};
